// extracted by mini-css-extract-plugin
module.exports = {"matchCentreCommentary":"matchCentreCommentary_matchCentreCommentary__Z7L3f"};